import { render, staticRenderFns } from "./EANEditor.vue?vue&type=template&id=620b3b88&"
import script from "./EANEditor.vue?vue&type=script&lang=js&"
export * from "./EANEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports